"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.dashboard.heading': 'Centro di pianificazione',
    'socialMediaPlan.dashboard.desc': 'Crea contenuto, scegli canali e pianifica.',
};
